import { useRoom } from "@liveblocks/react";
import { useEffect, useRef } from "react";
import { useNetworkStatusToast } from "./useNetworkStatusToast";

export function useConnectionStatus() {
  const room = useRoom();
  const hadError = useRef(false);
  const { networkIssueToast, networkRecoverToast } = useNetworkStatusToast();

  useEffect(() => {
    function onConnectionChange(state: string) {
      switch (state) {
        case "open": {
          if (hadError.current) {
            networkRecoverToast();
            hadError.current = false;
          }
          break;
        }
        case "unavailable":
        case "failed": {
          networkIssueToast();
          hadError.current = true;
          break;
        }
      }
    }
    const unsubcribe = room.subscribe("connection", onConnectionChange);
    return () => unsubcribe();
  });
}
